import React from "react";
import {Col, Container, Row} from "react-bootstrap";

const storiesgcc = () => {
  return (
    <div className="normal_section p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>Our Latest Web Design & Development Portfolio</h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <p>
            TekRevol is among the web development companies in Dubai that have developed numerous websites and web apps, but not all can be listed. Here are a few web design and development projects we have completed for our clients.
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default storiesgcc;
